import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { compose } from 'recompose'
// import { authenticateByCredentials } from 'actions/Auth'
import FollowSiplahView from 'components/publicPages/followSiplah'

const mapStateToProps = () => ({})

const mapDispatchToProps = () => ({
  // loginWithCredentials: bindActionCreators(authenticateByCredentials, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),

)(FollowSiplahView)
